import { useTreeItemModel } from "@mui/x-tree-view-pro";

import { RateBuilderTreeViewItem } from "@sinch/components/application/RatelistBuilder/types";

export const useIsParentWrapper = (parentId: string | null) => {
  const type = useTreeItemModel<RateBuilderTreeViewItem>(parentId ?? "")?.type ?? null;
  return type === "wrapper";
};
